import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { EvaluationInquiryApplicationsState } from '@/store/applications/evaluationInquiries/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

const EvaluationInquiryApplications: Module<EvaluationInquiryApplicationsState, RootState> = {
  state: () => ({
    applications: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
  }),
  mutations,
  actions,
  getters,
};

export default EvaluationInquiryApplications
